import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Header>
        <BackBtn onClick={() => navigate(-1)}><IoChevronBack size={24} /></BackBtn>
        <Title>이용약관</Title>
      </Header>
      <Content>
        <Section>
          <H2>제1조 (목적)</H2>
          <P>본 약관은 윤수빈 영어 연구소(이하 "연구소")가 제공하는 클래스매니지 서비스(이하 "서비스")의 이용조건 및 절차, 연구소와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.</P>
        </Section>

        <Section>
          <H2>제2조 (정의)</H2>
          <P>1. "서비스"란 연구소가 제공하는 학원 관리, 수업 관리, 출석 관리, 성적 관리, 메시지 전송 등 교육 관련 온라인 서비스를 말합니다.</P>
          <P>2. "이용자"란 본 약관에 따라 서비스를 이용하는 강사, 학생, 학부모, 조교 등을 말합니다.</P>
          <P>3. "계정"이란 이용자의 식별과 서비스 이용을 위해 이용자가 설정한 아이디와 비밀번호의 조합을 말합니다.</P>
        </Section>

        <Section>
          <H2>제3조 (약관의 효력 및 변경)</H2>
          <P>1. 본 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.</P>
          <P>2. 연구소는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있으며, 변경된 약관은 제1항과 같은 방법으로 공지합니다.</P>
        </Section>

        <Section>
          <H2>제4조 (서비스의 제공)</H2>
          <P>연구소는 다음 각 호의 서비스를 제공합니다.</P>
          <P>1. 클래스(수업) 관리 서비스</P>
          <P>2. 출석 관리 서비스</P>
          <P>3. 과제 및 시험 성적 관리 서비스</P>
          <P>4. 수업자료 및 수업영상 관리 서비스</P>
          <P>5. 메시지(공지) 전송 서비스</P>
          <P>6. 기타 연구소가 정하는 서비스</P>
        </Section>

        <Section>
          <H2>제5조 (이용자의 의무)</H2>
          <P>1. 이용자는 서비스 이용 시 관계 법령, 본 약관의 규정, 이용안내 및 서비스와 관련하여 공지한 주의사항을 준수하여야 합니다.</P>
          <P>2. 이용자는 타인의 개인정보를 무단으로 수집, 저장, 게시 또는 유포하여서는 안 됩니다.</P>
          <P>3. 이용자는 서비스를 이용하여 얻은 정보를 연구소의 사전 승낙 없이 복제, 전송, 출판, 배포, 방송 등의 방법으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.</P>
        </Section>

        <Section>
          <H2>제6조 (서비스 이용의 제한 및 중지)</H2>
          <P>1. 연구소는 다음 각 호에 해당하는 경우 서비스 이용을 제한하거나 중지할 수 있습니다.</P>
          <P>가. 서비스용 설비의 보수 등 공사로 인한 부득이한 경우</P>
          <P>나. 이용자가 본 약관의 의무를 위반한 경우</P>
          <P>다. 기타 불가항력적 사유가 있는 경우</P>
        </Section>

        <Section>
          <H2>제7조 (면책조항)</H2>
          <P>1. 연구소는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</P>
          <P>2. 연구소는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.</P>
        </Section>

        <Section>
          <H2>제8조 (분쟁해결)</H2>
          <P>서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우, 연구소의 소재지를 관할하는 법원을 관할법원으로 합니다.</P>
        </Section>

        <Footer>
          <FooterText>시행일: 2026년 2월 1일</FooterText>
        </Footer>
      </Content>
    </Container>
  );
};

export default TermsPage;

const Container = styled.div`
  background: white;
  min-height: 100vh;
  padding-bottom: 80px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid #E5E7EB;
`;

const BackBtn = styled.button`
  color: #111;
`;

const Title = styled.p`
  font-size: 18px;
  font-weight: 600;
`;

const Content = styled.div`
  padding: 20px 16px;
`;

const Section = styled.div`
  margin-bottom: 24px;
`;

const H2 = styled.h2`
  font-size: 15px;
  font-weight: 700;
  color: #111;
  margin-bottom: 8px;
`;

const P = styled.p`
  font-size: 13px;
  color: #444;
  line-height: 1.8;
  word-break: keep-all;
`;

const Footer = styled.div`
  margin-top: 32px;
  padding-top: 16px;
  border-top: 1px solid #E5E7EB;
`;

const FooterText = styled.p`
  font-size: 12px;
  color: #999;
`;
